module.exports = __webpack_public_path__ + "static/img/icon1.61227e9.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/productStage/icon1.png
// module id = 7ato
// module chunks = 44